<template>
    <div class="faq-category-question">
        <b-button
            class="btn-faq-category-answer-toggle"
            v-b-toggle="`question-toggle-${questionIn.id}`">
            {{ questionIn.question }}<i class="fas fa-fw fa-chevron-down state-icon"></i>
        </b-button>
        <b-collapse
            class="faq-category-answer"
            :id="`question-toggle-${questionIn.id}`"
            @input="updateState">
            <design-2021-apprentice-display-html-component v-html="questionIn.answer">
            </design-2021-apprentice-display-html-component>
        </b-collapse>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-faq-category-question-answer-component',
        props: {
            questionIn: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                selected: false,
            };
        },
        methods: {
            updateState(visible) {
                this.selected = visible;
            },
        },
    };
</script>

<style scoped lang="scss">
    ::v-deep ol {
        padding-left: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .faq-category-question-content {
        &:not(:last-child) {
            border-bottom: 3px dotted $border-color;
            padding-bottom: map-get($grid-gutter-spacing, 'eight');
            margin-top: 3px;
        }
    }

    .faq-category-question {
        margin-bottom: map-get($grid-gutter-spacing, 'ten');

        &:first-child {
            margin-top: map-get($grid-gutter-spacing, 'ten');
        }

        &.active {
            background-color: $secondary-background-color;
        }
    }

    .btn-faq-category-answer-toggle {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');
        background-color: $secondary-background-color;
        color: var(--primary);
        border: 1px solid $secondary-background-color;
        font-weight: $font-weight-bold;
        text-align: left;
        width: 100%;

        .state-icon {
            transform-origin: center;
            transition: all 0.8s ease;
        }

        &:hover,
        &:active,
        &:not(:disabled):not(.disabled):active {
            color: var(--primaryLightest);
            background-color: $secondary-background-color;
            border: 1px solid var(--primary);
        }

        &:focus,
        &:not(:disabled):not(.disabled):active:focus {
            box-shadow: none;
        }

        &.not-collapsed {
            color: var(--primaryLightest);
            border: 1px solid var(--primary);

            .state-icon {
                transform: rotate(-180deg);
            }

            & + .faq-category-answer {
                margin-top: -1px;
                border-left: 1px solid var(--primary);
                border-right: 1px solid var(--primary);
                border-bottom: 1px solid var(--primary);
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
            }
        }
    }

    .faq-category-answer {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
        line-height: 1.5;
        padding: map-get($grid-gutter-spacing, 'fifteen');
    }

    .btn-show-all {
        font-size: $default-font-size;
        font-weight: $font-weight-medium;
        padding: map-get($grid-gutter-spacing, 'four') map-get($grid-gutter-spacing, 'fifteen');
        border: 1px solid var(--primary);
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');
        margin-left: auto;

        &:hover {
            background-color: var(--primary);
            color: $white;
        }
    }
</style>
